<app-header></app-header>
<!--<app-breadcrumbs></app-breadcrumbs>-->
<app-content></app-content>
<footer class="sigma_footer footer-2 sigma_footer-dark">
    <app-footer></app-footer>
</footer>
